<template>
  <div class="modular-section-list clearfix">
    <div
      v-for="(item, index) in sysMenuList"
      ref="childDom"
      :key="index"
      :style="{'height':maxHeight}"
      class="modular-section-list-content"
    >
      <h5 class="modular-section-list-content-name"><i class="iconfont" :class="item.icon" style="margin-right: 10px;" />{{ item.name }}</h5>
      <ul class="modular-section-list-content-childList clearfix">
        <li v-for="(item1, index1) in item.childrenList" :key="index1">
          <span>{{ item1.name }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listdata: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      sysMenuList: [],
      maxHeight: 'unset'
    }
  },
  async created() {
    const { list = [] } = this.listdata
    list.map((item) => {
      item.icon = 'icon-' + item.icon
    })
    this.sysMenuList = list
  },
  mounted() {
    this.widthResize()
    window.onresize = () => {
      this.widthResize()
    }
  },
  methods: {
    widthResize() {
      let max = 0
      const vms = this.$refs.childDom || []
      vms.map((item) => {
        if (max < (item.children[0].offsetHeight + item.children[1].offsetHeight + 47)) {
          max = item.children[0].offsetHeight + item.children[1].offsetHeight + 47
        }
      })
      this.maxHeight = max + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
.clearfix:after,
.clearfix:before {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}
.clearfix {
  *zoom: 1;
}
.modular-section-list {
  margin-top: 20px;
  &-content {
    width: 20%;
    float: left;
    &-name {
      font-size: 14px;
      color: #333;
      font-weight: 600;
      margin: 20px;
      margin-bottom: 15px;
    }
    &-childList {
      padding: 0px 20px;
      margin-left: 25px;
      li {
        list-style: none;
        float: left;
        width: 50%;
        color: #666;
        font-size: 12px;
        margin-bottom: 10px;
        i {
          display: inline-block;
          margin-right: 6px;
          min-width: 16px;
          min-height: 16px;
        }
        span {
          width: calc(100% - 28px);
          display: inline-block;
          vertical-align: top;
          margin-top: 3px;
          line-height: 15px;
        }
      }
    }
  }
  &-content:nth-of-type(2n + 1) {
    border: 1px solid #f9f9f9;
    box-sizing: border-box;
  }
  &-content:nth-of-type(2n) {
    background-color: #f9f9f9;
  }
}
</style>
